import { useEffect } from 'react'

export default ({ query }) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [query])

  return null
}
